import { render, staticRenderFns } from "./RegisterShop.vue?vue&type=template&id=bfb39622&scoped=true"
import script from "./RegisterShop.vue?vue&type=script&lang=js"
export * from "./RegisterShop.vue?vue&type=script&lang=js"
import style0 from "./RegisterShop.vue?vue&type=style&index=0&id=bfb39622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb39622",
  null
  
)

export default component.exports